import React from 'react'
import Tabs from 'components/atoms/Tabs'
import ContentPanel from 'components/atoms/ContentPanel'
import SaleOrdersTable from 'modules/saleOrders/components/SaleOrdersTable'
import SuspendedSaleOrdersTable from 'modules/saleOrders/components/SuspendedSaleOrdersTable'

const SaleOrdersTabs = () => {
  const tabs = [
    {
      key: 'active',
      title: 'Aktywne',
      children: <SaleOrdersTable />,
      isList: true
    },
    {
      key: 'suspended',
      title: 'Wstrzymane',
      children: <SuspendedSaleOrdersTable />,
      isList: true
    }
  ]

  return (
    <ContentPanel>
      <Tabs tabs={tabs} />
    </ContentPanel>
  )
}

export default SaleOrdersTabs
